var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInterviewsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#b7d2dc",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6628 3174)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(6628 -3174)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.473,7.565H17.179a.474.474,0,0,1,.473.473V18.282a1.892,1.892,0,0,1-1.891,1.891H1.891A1.892,1.892,0,0,1,0,18.282V8.038A.474.474,0,0,1,.473,7.565ZM17.652,5.831V4.413A1.892,1.892,0,0,0,15.76,2.522H13.869V.473A.474.474,0,0,0,13.4,0H11.82a.474.474,0,0,0-.473.473V2.522H6.3V.473A.474.474,0,0,0,5.831,0H4.255a.474.474,0,0,0-.473.473V2.522H1.891A1.892,1.892,0,0,0,0,4.413V5.831A.474.474,0,0,0,.473,6.3H17.179A.474.474,0,0,0,17.652,5.831Z",
    transform: "translate(6631 -3172)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewsIcon);
export default __webpack_public_path__ + "static/media/interviews-icon.15d1b0bc.svg";
export { ForwardRef as ReactComponent };